













































































































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CsvResponsavelUsuarioSchema} from '@/schema/resource/ResponsavelUsuario/CsvResponsavelUsuarioSchema'
import {ResponsavelUsuarioCollection} from '@/model/collection/ResponsavelUsuarioCollection'
import {ListResponsavelUsuarioSchema} from '@/schema/resource/ResponsavelUsuario/ListResponsavelUsuarioSchema'

@Component
export default class ListResponsavelUsuarioView extends Mixins(
  MixinQueryRouter
) {
  @Prop() id?: number

  schema = new ListResponsavelUsuarioSchema()
  collection = new ResponsavelUsuarioCollection()

  async created() {
    this.collection.perPage = 20
    this.collection.idResp = this.id ?? 0
    if (this.id) await this.collection.listResponsavelUsuario(this.id)
    $.await.done('query')
  }

  async downloadXlsx() {
    if (!this.id) return

    const {ascending, orderBy, page, limit, ...params} = this.collection.params

    const collection = new ResponsavelUsuarioCollection()
      .clearFilters()
      .addFilter(params)

    await collection.listCsvResponsavelUsuario(this.id)
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvResponsavelUsuarioSchema(),
      $.t('schema.CsvResponsavelUsuario.title') as string
    )
  }

  getInactiveClass(index: number) {
    return this.collection.get(index).ativo ? '' : 'inactive'
  }

  goToEdit(id: number) {
    Helper.pushByName('editResponsavelUsuario', Number(this.id), id)
  }

  goToNew() {
    Helper.pushByName('editResponsavelUsuario', Number(this.id), 'new')
  }
}
